import api from "./api";
export type DeleteSalesDto = {
  id: number | string;
};

/*Search & Filter */

export const getSalesReturns = async (body: { limit: number; q: string }) => {
  let url = `/sales-returns?limit=${body.limit}&q=${body.q.toString()}`;
  return await api.get(url);
};
